import { useState } from "react";
import { FilterMatchMode } from "primereact/api";

const initialGlobalFilter = {
  global: { value: "", matchMode: FilterMatchMode.CONTAINS },
};

export const useTableBehavior = ({ initialSort, initialFilters } = {}) => {
  const [sort, setSort] = useState(initialSort || []);
  const [selectedRows, setSelectedRows] = useState([]);

  const [searchTextFilter, setSearchTextFilter] = useState(initialGlobalFilter);
  const [tableFilters, setTableFilters] = useState(initialFilters || {});

  const resetSearchTextFilter = () => {
    setSearchTextFilter(initialGlobalFilter);
  };

  const updateTableFilter = (field, value) => {
    setTableFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const updateTableFilters = (updates) => {
    setTableFilters((prevFilters) => ({
      ...prevFilters,
      ...updates,
    }));
  };

  const onSelectionChange = (e) => setSelectedRows(e.value);

  const clearSelectedRows = () => {
    setSelectedRows([]);
  };

  return {
    searchTextFilter,
    selectedRows,
    sort,
    tableFilters,
    clearSelectedRows,
    onSelectionChange,
    resetSearchTextFilter,
    setSearchTextFilter,
    setSelectedRows,
    setSort,
    setTableFilters,
    updateTableFilter,
    updateTableFilters,
  };
};
